module.exports = __webpack_public_path__ + "img/ic_fluent_resize_large_20_regular.8e1ef4b6.svg";